import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { RotatingText } from "@/components/shared/common";

/**
 * PreLoginLayout component that provides a consistent two-column layout for pre-login pages.
 * Includes the left column with branding content and rotating text animation.
 */
function PreLoginLayout() {
  const { t } = useTranslation(["translation", "components"]);

  return (
    <div className="flex h-screen">
      {/* Left column with branding content */}
      <div className="hidden md:flex w-1/3 bg-slate-950 items-center justify-center">
        <div className="text-white text-center flex flex-col gap-6 -mt-20">
          <img
            src="/assets/wisebid_logo_light.png"
            alt="Wisebid"
            className="h-10 mx-auto"
          />
          <div className="text-sm px-3 py-1.5 border border-white/30 rounded-md">
            {t("components:preloginbanner.subtitle")}
          </div>
          <div className="flex flex-col gap-4">
            <div className="text-xl font-semibold">{t("components:preloginbanner.tender")}</div>
            <RotatingText
              texts={[
                t("components:preloginbanner.view"),
                t("components:preloginbanner.edit"),
                t("components:preloginbanner.calculate"),
                t("components:preloginbanner.decide")
              ]}
              duration={2}
              className="text-3xl font-bold text-wisebid-purple"
            />
          </div>
        </div>
      </div>

      {/* Right column with page content */}
      <div className="w-full md:w-2/3 flex flex-col bg-white">
        {/* Logo at top left */}
        <div className="md:hidden p-6">
          <img
            src="/assets/wisebid_logo_dark.avif"
            alt="Wisebid"
            className="h-6"
          />
        </div>

        {/* Centered content */}
        <div className="flex-1 flex items-center justify-center">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default PreLoginLayout;
